import { QueryIntent } from '../../constants';

export const getUnifiedAIExperienceName: (
	smartAnswersRoute?: QueryIntent,
) =>
	| 'Person Card'
	| 'Team Card'
	| 'Location Card'
	| 'Date Card'
	| 'Topic Card'
	| 'Jira Card'
	| 'Agent Card'
	| 'Jira Issue Card'
	| 'Navigational'
	| 'None'
	| 'Default'
	| 'Plain Text'
	| 'Org Chart Card'
	| 'Nav Card'
	| 'Bookmark Knowledge Card'
	| 'Visual Card' = (smartAnswersRoute?: QueryIntent) => {
	switch (smartAnswersRoute) {
		case QueryIntent.PERSON:
			return 'Person Card';
		case QueryIntent.TEAM:
			return 'Team Card';
		case QueryIntent.LOCATION:
			return 'Location Card';
		case QueryIntent.DATE:
			return 'Date Card';
		case QueryIntent.TOPIC:
			return 'Topic Card';
		case QueryIntent.JIRA_NATURAL_LANGUAGE_QUERY:
			return 'Jira Card';
		case QueryIntent.AGENT:
			return 'Agent Card';
		case QueryIntent.JIRA_ISSUE:
			return 'Jira Issue Card';
		case QueryIntent.ORG_CHART:
			return 'Org Chart Card';
		case QueryIntent.NAVIGATIONAL:
			return 'Navigational';
		case QueryIntent.NAV_CONTENT:
			return 'Nav Card';
		case QueryIntent.BOOKMARK:
			return 'Bookmark Knowledge Card';
		case QueryIntent.VISUAL:
			return 'Visual Card';
		case QueryIntent.NONE:
			return 'None';
		case QueryIntent.DEFAULT:
			return 'Default';
		case QueryIntent.NATURAL_LANGUAGE_QUERY:
		case QueryIntent.KEYWORD_OR_ACRONYM:
		default:
			return 'Plain Text';
	}
};
